import { render, staticRenderFns } from "./StockImportForm.vue?vue&type=template&id=cc4bc8e8&"
import script from "./StockImportForm.vue?vue&type=script&lang=js&"
export * from "./StockImportForm.vue?vue&type=script&lang=js&"
import style0 from "./StockImportForm.vue?vue&type=style&index=0&id=cc4bc8e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports